// const ImageError = (props) => {
//   const [error, setError] = useState(false)

//   const onError = () => {

//   }

//   return (
//     <img 
//       src={props.thumbnail} 
//       onError={({ currentTarget }) => {
//         currentTarget.onerror = null; // prevents looping
//         currentTarget.src=`${props.output}`;
//       }}
//       style={{ width: 125 }} 
//       alt={`Votre montage`}
//     />
//   )
// }

// export default ImageError;


import React, { Component } from 'react';

class ImageError extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: props.thumbnail,
      errored: false,
    };
  }

  onError = () => {
    if (!this.state.errored) {
      this.setState({
        src: this.props.output,
        errored: true,
      });
    }
  }

  render() {
    const { src } = this.state;
    const {
      src: _1,
      fallbackSrc: _2,
      ...props
    } = this.props;

    return (
      <img 
        src={src} 
        onError={this.onError}
        alt={this.props.alt}
        {...props}
      />
      
    );
  }
}

export default ImageError;
